import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import FormPartial from './FormPartial.js';
import HeadUser from '../../models/HeadUser.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from "react-toastify";

const Edit = (props) => {
  let headUserObj = new HeadUser();
  const [headUser, setHeadUser] = useState(headUserObj.toStateJson());
  const [fetchApi] = getApi('showUser')
  const [updateApi] = getApi('updateUser');
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    getRecord({ id: params.id })
  }, []);

  const getRecord = async (params) => {
    try {
      let response = await fetchApi(params).unwrap();
      setHeadUser((new HeadUser(response.data.user, true)).toStateJson());
    } catch (error) {

    }
  }

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      toast.success('Head User Updated Successfully');
      navigate("/manage_users");
    } catch (error) {
      toast.error(error.data?.message);
      let headUserObj = new HeadUser(headUser);
      headUserObj.set_api_errors(error.data.data.errors);
    }
  }

  const handleSubmitFunction = () => {
    try{
      updateRecord(new HeadUser(headUser).toApiJson());
    } catch(error){
      console.log(error)
      setHeadUser(new HeadUser(headUser));
    }
  }

  const handleCancelFunction = () => {
    navigate('/manage_users');
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.EditHeadUserPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Head Users", url: '/manage_users' }, { label: "Edit" }]}
    className={'edit-head-user-page'}
  >
    <PageContentWrapper contentHeading={"Update Head User"}>
      <div className='m-3'>
        <div className='mb-4 col-md-12'>
          <form className="row g-3" autoComplete="off">
            <FormPartial headUser={headUser} setHeadUser={setHeadUser} />
            <div className='mb-4 col-md-12'>
              <div >
                <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>
                  Back
                </button>
                <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </PageContentWrapper>
  </Page>
}

export default Edit;
